export default {
  path: '/2019JJFP',
  name: '2019JJFP',
  component: () => import('./Home.vue'),
  redirect: '/2019JJFP/RelativeNews',
  meta: {
    title: '聚焦扶贫 福彩在行动',
  },
  children: [
    {
      path: 'RelativeNews',
      component: () => import('./RelativeNews.vue'),
      name: '2019JJFP/RelativeNews',
      meta: {
        title: '聚焦扶贫 福彩在行动',
      },
    },
    {
      path: 'SelectRules',
      component: () => import('./SelectRules.vue'),
      name: '2019JJFP/SelectRules',
      meta: {
        title: '聚焦扶贫 福彩在行动',
      },
    },
  ],
};
